import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { spotFinder } from '../app/endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';

export const serviceProviderFeedbackApi = createApi({
    reducerPath: 'serviceProviderFeedbackApi',
    baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
    tagTypes: ['serviceProvider'],
    endpoints: (builder) => ({
        findServiceProviderDetailByParkingId: builder.mutation({
            query(body) {
                return {
                    url: `${spotFinder.serviceProviderFeedbackController.findServiceProviderDetailByParkingId}${body.parkingId}`,
                    headers: body.token ? { Authorization: `Bearer ${body.token}` }: {},
                    method: 'GET',
                };
            },
        }),
        getAllServiceProviderFeedback: builder.mutation({
            query(body) {
                return {
                    url: spotFinder.serviceProviderFeedbackController.getAllServiceProviderFeedback,
                    method: 'POST',
                    headers: body.token ? { Authorization: `Bearer ${body.token}` } : {},
                    body: body.payload,
                };
            },
        }),
        saveServiceProviderFeedback: builder.mutation({
            query(body) {
                return {
                    url: `${spotFinder.serviceProviderFeedbackController.saveServiceProviderFeedback}`,
                    method: 'POST',
                    headers: body.token ? { Authorization: `Bearer ${body.token}` }: {},
                    body: body.payload,
                };
            },
        }),
    }),
});
export const {
    useFindServiceProviderDetailByParkingIdMutation,
    useSaveServiceProviderFeedbackMutation,
    useGetAllServiceProviderFeedbackMutation
} = serviceProviderFeedbackApi; 